export const SET_OPENED_MODAL = "SET_OPENED_MODAL";
export const SET_OPENED_MODAL_START = "SET_OPENED_MODAL_START";
export const CHANGE_HEADER_TYPE = "CHANGE_HEADER_TYPE";
export const CHANGE_CONDITION_SHOWN = "CHANGE_CONDITION_SHOWN";
